// @ts-nocheck
import { descriptionStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsDescription";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

Object.assign(descriptionStyles, {
    wrapper: {
        css: css`
            ${contentSpacingStyles(0, 0, pxToRem(15))}
        `,
    },
});
